import Parse from '@/parse'

const state = {
  options: []
}

const getters = {
  prefectures: (state) => {
    return state.options.filter((o) => {
      return o.get('category') === 'prefecture'
    })
  },

  accountTypes: (state) => {
    return state.options.filter((o) => {
      return o.get('category') === 'accountType'
    })
  },

  suits: (state) => {
    return state.options.filter((o) => {
      return o.get('category') === 'suit'
    })
  },

  entries: (state) => {
    return state.options.filter((o) => {
      return o.get('category') === 'entry'
    })
  },

  switchEntryStatus: (state, getters) => (entry) => {
    return getters.entries.filter((e) => {
      return e.id !== entry.id
    })[0]
  }
}

const mutations = {
  setOptions (state, options) {
    state.options = options
  }
}

const actions = {
  async retrieveOptions ({ commit }) {
    let query = new Parse.Query('Option')
    query.select('category', 'name', 'ja')
    const options = await query.find()
    commit('setOptions', options)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
